export default "__VITE_ASSET__Cjyp$WHX__"